import { useMessages } from 'hooks/hooks'
import {
    constants,
    Icon,
    Notification,
    Typography,
} from '@epidemicsound/design-system'
import styled from 'styled-components'
import { FC, useEffect } from 'react'

const { Text } = Typography

const StyledToastContainer = styled.div`
    z-index: 3000;
    background: ${constants.COLORS.WHITE};
    position: fixed;
    bottom: 0;
    right: 0;
    color: ${constants.COLORS.BLACK};
    min-width: 20%;

    span {
        color: ${constants.COLORS.BLACK};
    }
    margin: 1rem;
`

const StyledNotification = styled(Notification)`
    align-items: center;

    div {
        padding: 1.5rem;
    }
    span {
        color: ${constants.COLORS.BLACK};
    }

    ul {
        list-style: none;
    }
    ul li {
        margin-bottom: 0.5rem;
    }
`

const StyledCloseButton = styled.div`
    cursor: pointer;
    text-align: right;
    position: absolute;
    top: 5px;
    right: 5px;
`

export const Toast: FC = () => {
    const { message, removeMessage } = useMessages()

    const messages = message ? (
        <div>
            <ul>
                {message.messages.map((value, i) => {
                    return (
                        <li key={i}>
                            <Text>{value}</Text>
                        </li>
                    )
                })}
            </ul>
        </div>
    ) : undefined

    useEffect(() => {
        if (!message) return

        const timeout = setTimeout(() => {
            removeMessage()
        }, 5000)
        return () => clearTimeout(timeout)
    }, [message])

    return (
        <>
            {messages && message && (
                <StyledToastContainer>
                    <StyledCloseButton onClick={() => removeMessage()}>
                        <Icon.Close fill={constants.COLORS.BLACK} />
                    </StyledCloseButton>
                    <StyledNotification
                        message={messages}
                        type={message.type}
                    />
                </StyledToastContainer>
            )}
        </>
    )
}
